import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import DashboardPassportFileItem from "components/DashboardPassportFileItem";
import DashboardSortTableHeader from "components/DashboardSortTableHeader";
import styles from "./DashboardPassportFileTable.module.css";

const DashboardPassportFileTable = ({
  items,
  onChangeSelectedFiles,
  onDelete,
  showDelete
}) => {
  const [tableItems, setTableItems] = useState([]);
  const [sortCriteria, setSortCriteria] = useState({
    column: "name",
    direction: "asc",
  });

  const handleSort = (column) => {
    setSortCriteria((prevCriteria) => {
      if (prevCriteria.column === column) {
        const newDirection = prevCriteria.direction === "asc" ? "desc" : "asc";
        return { column, direction: newDirection };
      } else {
        return { column, direction: "asc" };
      }
    });
  };

  useEffect(() => {
    setSortCriteria({ column: "name", direction: "asc" });
  }, []);

  useEffect(() => {
    setTableItems([...items]);
  }, [items])

  const sortedItems = [...tableItems].sort((a, b) => {
    const aValue = a[sortCriteria.column];
    const bValue = b[sortCriteria.column];
    if (sortCriteria.direction === "asc") {
      return aValue > bValue ? 1 : -1;
    } else {
      return aValue < bValue ? 1 : -1;
    }
  });

  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelect = (index) => {
    let newSelecteds = [];
    if (selectedItems.includes(index)) {
      newSelecteds = selectedItems.filter((itemIndex) => itemIndex !== index);
    } else {
      newSelecteds = [...selectedItems, index];
    }

    console.log("Selected items: ", newSelecteds);

    setSelectedItems([...newSelecteds]);
    onChangeSelectedFiles(newSelecteds.map((m) => sortedItems[m]));
  };

  const formatRequirementName = (reqName) => {
    if (!reqName || reqName.trim() === "") return "Docs";

    const specialNames = [
      "Checkr Background Check",
      "CPNW WATCH",
      "Independent Background Check",
      "Independent WATCH"
    ];

    if (specialNames.includes(reqName)) return reqName;

    if (reqName.startsWith("CPNW:")) {
      return reqName.replace("CPNW:", "").trim();
    }

    return reqName;
  };

  const shortenFileName = (name) => {
    if (!name) return "";
    if (name.length <= 15) return name;
    return name.substring(0, 15) + "…";
  };

  return (
    <div className={styles.tableContainer}>
      <table className={styles.fileTable}>
        <thead>
          <tr>
            <th style={{ width: "30%", paddingLeft: "33px" }}>
              <DashboardSortTableHeader
                title="File Name"
                onChange={() => handleSort("name")}
                value={
                  sortCriteria.column === "name" ? sortCriteria.direction : ""
                }
                width={320} // Adjust width as needed
              />
            </th>
            <th style={{ width: "20%" }}>
              <DashboardSortTableHeader
                title="Requirement"
                onChange={() => handleSort("requirementName")}
                value={
                  sortCriteria.column === "requirementName"
                    ? sortCriteria.direction
                    : ""
                }
                width={260}
              />
            </th>
            <th style={{ width: "30%" }}>
              <DashboardSortTableHeader
                title="Upload Date"
                onChange={() => handleSort("uploadDate")}
                value={
                  sortCriteria.column === "uploadDate"
                    ? sortCriteria.direction
                    : ""
                }
                width={180} // Adjust width as needed
              />
            </th>
            {showDelete && <th style={{ width: "20%" }}>Remove</th>}
          </tr>
        </thead>
        <tbody>
          {sortedItems.length === 0 ? (
            <tr>
              <td colSpan="3" className={styles.noData}>
                No data available in table
              </td>
            </tr>
          ) : (
            sortedItems.map((item, index) => (
              <DashboardPassportFileItem
                key={index}
                selected={selectedItems.includes(index)}
                onSelect={() => handleSelect(index)}
                onTrash={() => {
                  console.log(`Trash clicked for item ${index}`);
                  //index is sorted index
                  //get tableItems index
                  const item = sortedItems[index];
                  const tableIndex = tableItems.findIndex((m) => m.name === item.name && m.uploadDate === item.uploadDate);
                  onDelete(tableIndex);
                }}
                onClick={() =>
                  console.log(`File name clicked for item ${index}`)
                }
                info={{
                  ...item,
                  shortName: shortenFileName(item.name),
                  formattedRequirement: formatRequirementName(
                    item.requirementName
                  ),
                }}
                showDelete={showDelete}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

DashboardPassportFileTable.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      requirementName: PropTypes.string,
      uploadDate: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default DashboardPassportFileTable;
